module.exports = __webpack_public_path__ + "img/how-to-cook-pasta-6.e353a40e.jpg";